
import { Component, Vue, Prop, Watch, Emit, Ref, Mixins } from 'vue-property-decorator'
import InfiniteLoading from '@xt/www/components/infinite-loadingv2/index.vue'
import { dataSource_topicManagerFilter } from '@xt/client/dataSource/kindred-spirit'
import { EnumJoinStatus, EnumGuildMemberType, EnumJoinGroupStatus, EnumMemberStatus } from '@xt/client/enums/kindred-spirit'
import HeaderImage from '@xt/www/components/headerImage/index.vue'
import lodash from 'lodash'
import { Observer } from 'mobx-vue'
import { dataSource_My } from '@xt/client/dataSource/my'
import ConfirmModal from '../components/ConfirmModal/index.vue'
import { ConfirmModalOptions } from '@xt/client/entities/kindred-spirit/kindred-spirit'

@Observer
@Component({
  components: {
    HeaderImage,
    InfiniteLoading,
    ConfirmModal
  },
  async asyncData(ctx) {
    const guildId = ctx.query.id as string
    // 初始化页面数据
    await ctx.store.$tonghao.Manager.initPage()

    // 是否是负责人前置校验
    const { id, memberType } = ctx.store.$tonghao.Manager.joinedCity!
    const isManager = id.toString() === guildId && memberType === EnumGuildMemberType.Manager

    if (!isManager) {
      ctx.redirect('/')
    }
  },
  validate({ query }) {
    return /^\d+$/.test(query.id as string)
  }
})
export default class ManagerPage extends Vue {
  searchValue: string = ''
  filterValue: string = ''

  visible: boolean = false

  // 本地缓存弹窗显示状态，key为memberId，value为显隐布尔
  popVisibleMap = new Map<string, boolean>()

  @Ref()
  confirmModal: {
    show: (options: ConfirmModalOptions) => Promise<boolean>
  }

  get guildId() {
    return this.$route.query.id as string
  }

  get EnumMemberStatus() {
    return EnumMemberStatus
  }

  get EnumJoinGroupStatus() {
    return EnumJoinGroupStatus
  }

  get body() {
    return {
      guildId: this.guildId,
      status: this.filterValue ?? undefined,
      keyword: this.searchValue ?? undefined
    }
  }

  get UserInfo() {
    return this.$store.$storeUser.UserInfo
  }

  get PageStore() {
    return this.$store.$tonghao.Manager
  }

  get filterLabel() {
    const i = lodash.find(dataSource_topicManagerFilter, ['key', this.filterValue])
    return i ? i.label : dataSource_topicManagerFilter[0].label
  }

  get sortOptions() {
    return dataSource_topicManagerFilter
  }

  async openUserInfoModal(user, key: 'exit' | 'remove' | 'join') {
    let confirmText: string = ''

    if (key === 'join') {
      confirmText = '确认入群'
    } else if (key === 'exit') {
      confirmText = '确认退出'
    } else if (key === 'remove') {
      confirmText = '确认移出'
    }

    const res = await this.confirmModal.show({
      layoutClassName: 'user-info-confirm-modal',
      confirmedHide: true,
      confirmText,
      cancelText: '取消',
      contentData: user
    })

    if (res === true) {
      if (key === 'join') {
        this.handleJoin(user.memberId)
      } else if (key === 'exit') {
        const res = await this.PageStore.exitAudit({
          guildId: this.guildId,
          memberId: user.memberId
        })
        if (res === true) {
          this.$message.success('退出成功')
          this.refreshList()
        }
      } else if (key === 'remove') {
        const res = await this.PageStore.exitAudit({
          guildId: this.guildId,
          memberId: user.memberId
        })
        if (res === true) {
          this.$message.success('移出成功')
          this.refreshList()
        }
      }
    }
  }

  async handleJoin(memberId: string) {
    const res = await this.PageStore.joinGroup({
      guildId: this.guildId,
      memberId
    })

    if (res === true) {
      this.$message.success('入群成功')
      this.refreshList()
    }
  }

  getlabelStyle(item: string) {
    const styles: Array<string> = []
    const option = dataSource_My.specialtyOptions.filter(i => i.value === item)

    if (!option.length) return ''

    styles.push(`color: ${option[0].color}`)
    styles.push(`background: ${option[0].background}`)

    return styles.join(';')
  }

  handleFilter({ key, domEvent }: { key: EnumJoinStatus; domEvent: MouseEvent }) {
    // 防止点击下拉菜单再次弹出
    domEvent.stopPropagation()

    if (this.filterValue === key) return

    this.filterValue = key

    this.refreshList()
  }

  refreshList() {
    this.PageStore.pagePagination.clearData(this.body)
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
